<template>
  <v-container>
    <v-layout row>
      <v-flex xs12>
        <v-card>
          <v-toolbar color="blue darken-3" dark>
            <v-toolbar-title>Change Password</v-toolbar-title>

            <v-spacer></v-spacer>
          </v-toolbar>

          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-text-field
                type="password"
                v-model="password"
                :counter="50"
                label="password"
                :rules="rules.password"
                maxlength="50"
                required
              ></v-text-field>

              <v-text-field
                type="password"
                v-model="password1"
                :counter="50"
                label="confirm password"
                :rules="rules.password1"
                maxlength="50"
                :error-messages="matchError()"
                required
              ></v-text-field>
            </v-container>
            <v-btn class="blue white--text" :disabled="!valid" @click="submit"
              >submit</v-btn
            >
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Snackbar -->
    <v-snackbar v-model="notification" top left color="blue" :timeout="timeout">
      {{ text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { router } from "../router";
import jwt_decode from "jwt-decode";
import axios from "axios";
import { config } from "../config/config";
import { checkLogin } from '../helpers/check'

export default {
  data: () => ({
    notification: false,
    timeout: 6000,
    text: "",
    //portalUrl : "http://localhost:8000/api/",
    portalUrl: config.apiUrl,
    id: "",
    username: "",
    password: "",
    password1: "",
    valid: false,
    loading: false,
    rules: {
      password: [
        v => !!v || "Password is required",
        v =>
          (v && v.length > 4) || "The password must be longer than 7 characters"
      ],
      password1: [
        v => !!v || "Password is required",
        v =>
          (v && v.length > 4) || "The password must be longer than 7 characters"
      ]
    }
  }),

  computed: {},

  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        axios
          .put(this.portalUrl + "users/" + this.id + "/", {
            username: this.username,
            password: this.password
          })
          .then(res => {
            this.notification = true;
            this.text = "Your password has been saved.";
          })
          .catch(e => {
            this.loading = false;
            this.notification = true;
            this.text = "Oops! Something went wrong, try again later.";
          });
      }
    },
    matchError() {
      return this.password === this.password1 ? "" : "Passwords must match";
    },
    checkLoggedIn() {
      if (checkLogin()) {
        router.push("/login");
      }
      else {
        this.retrieveUser();
      }
    },
    retrieveUser() {
      axios.defaults.headers.common["Authorization"] =
        "JWT " + sessionStorage.getItem("token");
      this.loading = true;
      axios
        .get(this.portalUrl + "current-user/")
        .then(res => {
          if (res && res.data && res.data.id) {
            this.id = res.data.id;
            this.username = res.data.username;
          }
        })
        .catch(e => {
          this.loading = false;
        });
    },
    inspectToken() {
      const token = this.$session.has("token");
      if (token) {
        const decoded = jwt_decode(sessionStorage.getItem("token"));
        const exp = decoded.exp;
        const orig_iat = decoded.orig_iat;

        if (exp - Date.now() / 1000 < 1800) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
  },
  mounted: function() {
    this.checkLoggedIn();
  }
};
</script>
